import React from 'react';
import PropTypes from 'prop-types';
import handleEvent from "../../common/events/HandleEvent";
import PopupWindowKeypressEventHandlerManager from './PopupWindowKeypressEventHandlerManager';
import joinClassNames from "../../common/JoinClassNames";
import commonAppSetup from "../../common/common-app-setup/CommonAppSetup";
import Components from "../../common/Components";

const propTypes = {
	// the contents of the popup window
	children: PropTypes.node,

	// className is for the popup-window div
	className: PropTypes.string,

	// icon override for the close button
	closeIcon: PropTypes.node,

	// footer under the popup window for other buttons such as: Okay, Cancel, Save, etc...
	footerChildren: PropTypes.node,

	// callback for the backdrop getting click
	onBackdropCallback: PropTypes.func,

	// callback for the close button or user hitting esc key
	onCloseButtonCallback: PropTypes.func,

	// callback for the user pressing the enter/return key
	onEnterKeyPressed: PropTypes.func,
};

const defaultProps = {
	className: '',
	closeIcon: undefined,
	footerChildren: undefined,
	onBackdropCallback: undefined,
	onCloseButtonCallback: undefined,
	onEnterKeyPressed: undefined,
};

// container popup window component that hovers modally over current content on the page
// this is a translation of main.js::setupPopupWindow/createPopupWindow
// to close this window external to this component: update your state so that the popupwindow should not be shown and then when it rerenders it will go away
export default class PopupWindow extends React.Component {
	constructor(props) {
		super(props);
		this.handleBackdropClick = this.handleBackdropClick.bind(this);
		this.popupEventManager = new PopupWindowKeypressEventHandlerManager();
		this.eventManagerId = this.popupEventManager.registerListener();
	}

	componentDidMount() {
		this.popupEventManager.addEventCallback(this.eventManagerId, this.keyPressed.bind(this));
	}

	componentWillUnmount() {
		this.popupEventManager.removeEventCallback(this.eventManagerId);
	}

	keyPressed(e) {
		let result = true;
		if (e.keyCode === 27) {
			result = this.props.onCloseButtonCallback ? this.props.onCloseButtonCallback() : false;
		} else if (e.keyCode === 13) {
			result = this.props.onEnterKeyPressed ? this.props.onEnterKeyPressed() : false;
		}
		return result;
	}

	handleBackdropClick(e) {
		if (this.props.onBackdropCallback) {
			this.props.onBackdropCallback(e);
		}
	}

	render() {
		let closeButton = undefined;
		if (this.props.onCloseButtonCallback) {
			closeButton = <a href="#" className="popup-window__close-button" onClick={handleEvent(this.props.onCloseButtonCallback)}>Close{this.props.closeIcon ? this.props.closeIcon : <svg viewBox="0 0 9.9 9.9" className="icon-close" role="presentation"><title>icon-close</title><rect x="3.95" y="-1.05" width="2" height="12" transform="translate(-2.05 4.95) rotate(-45)"/><rect x="3.95" y="-1.05" width="2" height="12" transform="translate(4.95 11.95) rotate(-135)"/></svg>}</a>;
		}

		let footer = undefined;
		if (this.props.footerChildren) {
			footer = <div className="popup-window__footer">{this.props.footerChildren}</div>;
		}

		return (
			<div className={joinClassNames('popup-window__backdrop', commonAppSetup.getClassName(Components.POPUP_WINDOW, 'wrapper'))} onClick={this.handleBackdropClick}>
				<div className={joinClassNames(this.props.className, "popup-window")} onClick={(e) => e.stopPropagation()}>
					<div className={joinClassNames('popup-window__content', commonAppSetup.getClassName(Components.POPUP_WINDOW, 'content'))}>
						{this.props.children}
					</div>
					{closeButton}
					{footer}
				</div>
			</div>
		);
	}
}

PopupWindow.defaultProps = defaultProps;

PopupWindow.propTypes = propTypes;
